import { render, staticRenderFns } from "./SingleSNPMRDoc.vue?vue&type=template&id=9698f8b2&"
import script from "./SingleSNPMRDoc.vue?vue&type=script&lang=js&"
export * from "./SingleSNPMRDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports